import axios from "config/axios";
import { GenericListResponse, GenericPageResponse } from "shared/common";
import { BaseCurrency, Department } from "shared/types";
import { CashRegister } from "./cash-register.api";

export type Receipt = {
  cashRegister: CashRegister | null;
  department: Department | null;
  currency: BaseCurrency;
  grossPriceA: number;
  grossPriceB: number;
  grossPriceC: number;
  grossPriceE: number;
  id: number;
  netPriceA: number;
  netPriceB: number;
  netPriceC: number;
  netPriceE: number;
  releaseDate: string;
  tenantId: number;
  vatPercentageA: number;
  vatPercentageB: number;
  vatPercentageC: number;
  vatPercentageE: number;
  vatPriceA: number;
  vatPriceB: number;
  vatPriceC: number;
  vatPriceE: number;
};

const ENDPOINT = "/receipt-summary";

export const createReceipt = (param: Partial<Receipt>, tenantId: number) => {
  return axios.post<GenericPageResponse<any>>(`${ENDPOINT}`, { param, tenantId });
};

export const uploadCsvReceipt = (file: File, forceImport: boolean, tenantId: number) => {
  const formData = new FormData();

  formData.append("file", file);
  formData.append("forceImport", forceImport + "");
  formData.append("tenantId", tenantId.toString());

  return axios.post<GenericPageResponse<any>>(`${ENDPOINT}/import-from-csv`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const listReceiptPageable = (
  page: number,
  size: number,
  tenantId: number,
  search: string = "",
  sort: string = "",
) =>
  axios.get<GenericPageResponse<Receipt>>(
    `${ENDPOINT}/all?page=${page}&size=${size}&tenantId=${tenantId}&search=${search}&sort=${sort}`,
  );

export type ReceiptStatistics = {
  summary: [
    {
      currencyCode: string;
      netA: number;
      vatA: number;
      grossA: number;
      netB: number;
      vatB: number;
      grossB: number;
      netC: number;
      vatC: number;
      grossC: number;
      netE: number;
      vatE: number;
      grossE: number;
    },
  ];
  day?: string;
  week?: {
    start: string;
    end: string;
  };
  month?: {
    start: string;
    end: string;
  };
};

export const getReceiptStatistics = ({
  tenantId,
  granularity,
  from,
  to,
  cashRegisterId,
}: {
  granularity: "DAILY" | "WEEKLY" | "MONTHLY";
  tenantId: number;
  from: string;
  to: string;
  cashRegisterId?: string | number | undefined;
}) =>
  axios.get<GenericListResponse<ReceiptStatistics>>(
    `${ENDPOINT}/get-receipt-summary-statistic?tenantId=${tenantId}&granularity=${granularity}&from=${from}&to=${to}${
      cashRegisterId ? `&cashRegisterId=${cashRegisterId}` : ""
    }`,
  );
